import { Building } from "./../grpc/code-gen/building_pb.d";
import store from "@/store";
/* eslint-disable no-console */
import { v4 as uuidv4 } from "uuid";
import Infrastructure from "@/infrastructure";
const infra = new Infrastructure();
import useNotification from "@/composables/useNotification";
import { LockerServiceBuilding } from "@/grpc/code-gen/db_pb";
const { notify } = useNotification();

export default {
  namespaced: true,
  state: {
    buildings: [] as Array<Building.AsObject>,
    allBuildings: [] as Array<Building.AsObject>,
    merusoftBuildings: [] as Array<LockerServiceBuilding.AsObject>,
    emptyBuilding: {
      id: undefined,
      name: "Не найдено",
      city: "",
      floorsList: [],
      img: "",
      coworkingtotalseats: "",
      issmartoffice: false,
      smartofficeid: 0,
      guestfloorsList: [],
      address: "",
      direction: "",
      securityemail: "",
      canteenemail: "",
      lockerstotal: ""
    } as any
  } as any,
  actions: {
    async loadBuildingsList(s: any, city: string): Promise<void> {
      return await new Promise((resolve, reject) => {
        infra.location
          .GetBuildingsList(city)
          .then((response) => {
            if (response) {
              s.commit("addBuildingsList", response.buildingList);
              resolve();
            } else {
              reject();
            }
          })
          .catch((error) => {
            reject();
          });
      });
    },
    async loadAllBuildingsList(s: any): Promise<void> {
      return await new Promise((resolve, reject) => {
        infra.location
          .GetAllBuildingsList()
          .then((response) => {
            if (response) {
              s.commit("addAllBuildingsList", response.buildingList);
              resolve();
            } else {
              reject();
            }
          })
          .catch((error) => {
            reject();
          });
      });
    },
    async loadMerusoftBuildingList(s: any): Promise<void> {
      return await new Promise((resolve, reject) => {
        infra.location
          .GetMerusoftBuildingsList()
          .then((response) => {
            if (response) {
              s.commit(
                "addMerusoftBuildingList",
                response.lockerservicebuildingList
              );
              resolve();
            } else {
              reject();
            }
          })
          .catch((error) => {
            reject();
          });
      });
    },
    async addBuilding(state: any, payload: Building.AsObject): Promise<void> {
      try {
        const response = await infra.location.AddBuilding(payload);
        console.log("add building success  ", response);
        state.dispatch("loadAllBuildingsList");
      } catch (error) {
        console.log("add building failed", error);
        store.commit("setNetworkError");
        notify(`Не удалось создать здание. Попробуйте еще раз`, "error");
        throw error;
      }
    },
    async updBuilding(state: any, payload: Building.AsObject): Promise<void> {
      try {
        const response = await infra.location.UpdBuilding(payload);
        console.log("upd building success  ", response);
        state.dispatch("loadAllBuildingsList");
      } catch (error) {
        console.log("upd building failed", error);
        store.commit("setNetworkError");
        notify(`Не удалось сохранить здание. Попробуйте еще раз`, "error");
        throw error;
      }
    },
    async delBuilding(state: any, payload: Building.AsObject): Promise<void> {
      try {
        const response = await infra.location.DelBuilding(payload);
        console.log("del building success  ", response);
        state.dispatch("loadAllBuildingsList");
      } catch (error: any) {
        console.log("del building failed", error);
        store.commit("setNetworkError");
        const errorMessage = `Не удалось удалить здание. Детали ошибки: ${error.message}`;
        notify(errorMessage, "error");
        throw error;
      }
    }
  },
  mutations: {
    addBuildingsList(state: any, payload: any) {
      state.buildings = payload;
    },
    addAllBuildingsList(state: any, payload: any) {
      state.allBuildings = payload;
    },
    addMerusoftBuildingList(state: any, payload: any) {
      state.merusoftBuildings = payload;
    },
    editCityInBuildings(state: any, payload: any) {
      state.buildings = state.buildings.map((b) =>
        b.city === payload.city ? { ...b, city: payload.newCityName } : b
      );
    },
    addBuilding(state: any, payload: any) {
      state.buildings.push({
        id: uuidv4(),
        name: payload.name,
        city: payload.city,
        floors: []
      });
    },
    editBuildingName(state: any, payload: any) {
      state.buildings.find((b) => b.id === payload.id).name =
        payload.newBuildingName;
    },
    addFloor(state: any, payload: any) {
      state.buildings
        .find((b) => b.id === payload.id)
        .floors.push(payload.newFloor);
    },
    editBuildingFloor(state: any, payload: any) {
      const floorsInBuilding = state.buildings.find(
        (b) => b.id === payload.building
      ).floors;
      const editableFloorIndex = floorsInBuilding.indexOf(payload.floor);
      floorsInBuilding.splice(editableFloorIndex, 1, payload.newFloor);
    }
  },
  getters: {
    getBuildings: (s: any) => s.buildings,
    getAllBuildings: (s: any) => s.allBuildings,
    getMerusoftBuildings: (s: any) => s.merusoftBuildings,
    getBuildingById: (state: any) => (id: string) => {
      const obj = state.allBuildings.filter((building) => {
        return building.id === id;
      })[0];
      return obj || state.emptyBuilding;
    },
    getBuildingsByCityId: (s: any) => (id: string) => {
      return s.allBuildings.filter((b) => b.city === id);
    }
  }
};
